var def = require('./_object-dp').f
  , has = require('./_has')
  , TAG = require('./_wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_set-to-string-tag.js
// module id = 60
// module chunks = 2 3 4 5 6 7 8 9 10 11 12